module.exports = __webpack_public_path__ + "static/media/mu-logo (copy).50f90c9f.png";